var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.571,
    height: 61.571,
    viewBox: "0 0 61.571 61.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-line",
    "data-name": "Icon metro-chart-line",
    d: "M61.571,59.016H56.445V56.445H53.874v2.571H48.756V56.445H46.186v2.571H41.06V56.445H38.49v2.571H33.364V56.445H30.793v2.571H25.667V56.445H23.1v2.571H11.806l13.52-8.125,6.691-19.554,9.939,17.468L61.214,16.717l-4.4-2.642L42.073,38.641,30.847,18.91,21.075,47.458,7.7,55.5V2.571H2.571V64.141H64.141v-7.7H61.571Zm0-56.445h2.571V5.141H61.571Zm-7.7,0h2.571V5.141H53.874Zm-7.689,0h2.571V5.141H46.186Zm-7.7,0H41.06V5.141H38.49Zm-7.7,0h2.571V5.141H30.793Zm-7.7,0h2.571V5.141H23.1Zm-7.7,0h2.571V5.141H15.4Zm-7.7,0h2.571V5.141H7.7Zm53.867,7.7h2.571v2.571H61.571Zm-7.7,0h2.571v2.571H53.874Zm-7.689,0h2.571v2.571H46.186Zm-7.7,0H41.06v2.571H38.49Zm-7.7,0h2.571v2.571H30.793Zm-7.7,0h2.571v2.571H23.1Zm-7.7,0h2.571v2.571H15.4Zm-7.7,0h2.571v2.571H7.7Zm53.867,7.689h2.571v2.571H61.571Zm-15.385,0h2.571v2.571H46.186Zm-7.7,0H41.06v2.571H38.49Zm-15.393,0h2.571v2.571H23.1Zm-7.7,0h2.571v2.571H15.4Zm-7.7,0h2.571v2.571H7.7Zm53.867,7.7h2.571v2.571H61.571Zm-23.081,0H41.06v2.571H38.49Zm-15.393,0h2.571v2.571H23.1Zm-7.7,0h2.571v2.571H15.4Zm-7.7,0h2.571v2.571H7.7Zm53.867,7.7h2.571v2.571H61.571Zm-7.7,0h2.571v2.571H53.874Zm-38.474,0h2.571v2.571H15.4Zm-7.7,0h2.571v2.571H7.7Zm53.867,7.7h2.571V43.62H61.571Zm-7.7,0h2.571V43.62H53.874Zm-23.081,0h2.571V43.62H30.793Zm-15.393,0h2.571V43.62H15.4Zm-7.7,0h2.571V43.62H7.7Zm53.867,7.689h2.571v2.571H61.571Zm-7.7,0h2.571v2.571H53.874Zm-7.689,0h2.571v2.571H46.186Zm-15.393,0h2.571v2.571H30.793Zm-23.089,0h2.571v2.571H7.7Z",
    transform: "translate(-2.571 -2.571)",
    fill: "#f6d515"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.5e0d4fdf27bc8336edd7b0491b3bc99b.svg";
export { ForwardRef as ReactComponent };